var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FilterSection',{attrs:{"title":"Document type"}},[_c('MultipleSelect',{attrs:{"id":"multi-select-incorp-type","items":_vm.multiSelectOptions,"config":_vm.multiSelectConfig},on:{"multipleSelection":_vm.toggleCheckbox}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }